import React, { useEffect, useState } from 'react'
import assetcapture from "../../../images/asset capture.png"
import assetprinting from "../../../images/asset for printing.png"
import assetverified from "../../../images/verified asset.png"
import userRequest from "../../../utils/userRequest"
import { Link, useNavigate } from 'react-router-dom';
import ViewportMeta from '../../../utils/ViewportMeta';
import CustomSnakebar from '../../../utils/CustomSnakebar';
import { allUserAssetsColumns } from '../../../datatablesource';
import DashboardTable from '../../../components/userAdminPanel/dashboardTable/DashboardTable';
import { useTranslation } from 'react-i18next';

const AssetsDashboard = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const [roles, setRoles] = useState([]);
  const [error, setError] = useState(null);
  const [newassetData, setNewAssetData] = useState([]);
  const [PrintingAssetData, setPrintingAssetData] = useState([]);
  const [allVerifiedAssetsList, setAllVerifiedAssetsList] = useState([]);
  useEffect(() => {
    // new.get('/userRoles')
    userRequest.get("/userRoles").then(response => {
        setRoles(response?.data ?? []);
      }).catch(error => {
        setError(error?.response?.data?.message ?? "Something went wrong");
      });

    const getAllAssetsList = async () => {
      try {
        userRequest.get("/getAllAssetMasterEncodeAssetCaptureWithNoTag")
          .then(response => {
            const sortedData = response.data.sort((a, b) => new Date(b.assetdatecaptured) - new Date(a.assetdatecaptured));
            response.data == "no data available" ? setNewAssetData([]) : setNewAssetData(response.data);
          })
          .catch(error => {
            if (error?.response?.status == 401) {
              setError("Session expired, please login again");
            } else {
              setError(error?.response?.data?.message ?? "Something went wrong");
            }
          });
      }
      catch (error) {
        console.log(error);

      }
    };

    const getPrintingAssets = async () => {
      userRequest.get("/GetAllAssetMasterEncodeAssetCapture")
        .then(response => {
          setPrintingAssetData(response?.data ?? []);
        }).catch(error => {
          if (error?.response?.status == 401) {
            setError("Session expired, please login again");
            // setTimeout(() => {
            //   navigate("/userLogin");
            // }, 2000);
          } else {
            setError(error?.response?.data?.message ?? "Something went wrong");
          }

        });

    };

    const getAllVerifiedAssets = async () => {
      userRequest.get("/GetAllAssetMasterEncodeAssetCaptureFinal")
        .then(response => {
          const sortedData = response.data.sort((a, b) => new Date(b.assetdatecaptured) - new Date(a.assetdatecaptured));
          setAllVerifiedAssetsList(response?.data ?? []);
        }).catch(error => {
          if (error?.response?.status == 401) {
            setError("Session expired, please login again");
            // setTimeout(() => {
            // navigate("/userLogin");
            // }, 2000);
          } else {
            setError(error?.response?.data?.message ?? "Something went wrong");
          }
        });
    };

    getAllAssetsList();
    getPrintingAssets();
    getAllVerifiedAssets();

  }, []);

  const resetSnakeBarMessages = () => {
    setError(null);
  };

  const handleNavigation = (tabName) => {
    //  check if the user has the role to access the tab and then navigate to the tab
    switch (tabName) {
      case "assetCapture":
        if (roles.includes(9) || roles.includes(1)) {
          navigate('/userdetails')
        } else {
          setError("You don't have access to this tab")
        }
        break;
      case "generateTags":
        if (roles.includes(2) || roles.includes(1)) {
          navigate('/newasset')
        }
        else {
          setError("You don't have access to this tab")
        }
        break;
      case "assetForPrinting":
        if (roles.includes(3) || roles.includes(1)) {
          navigate('/userprinting')
        }
        else {
          setError("You don't have access to this tab")
        }
        break;
      case "verifiedAssets":
        if (roles.includes(4) || roles.includes(1)) {
          navigate('/verifiedasset')
        }
        else {
          setError("You don't have access to this tab")
        }
        break;
      case "custodian":
        if (roles.includes(5) || roles.includes(1)) {
          navigate('/cust')
        }
        else {
          setError("You don't have access to this tab")
        }
        break;
      case "location":
        if (roles.includes(6) || roles.includes(1)) {
          navigate('/location')
        }
        else {
          setError("You don't have access to this tab")
        }
        break;
      case "assetInventory":
        if (roles.includes(7) || roles.includes(1)) {
          // navigate('#')
        }
        else {
          setError("You don't have access to this tab")
        }
        break;
      case "verify":
        if (roles.includes(8) || roles.includes(1)) {
          navigate('/verify')
        }
        else {
          setError("You don't have access to this tab")
        }
        break;
      case "admin":
        if (roles.includes(1) || roles.includes(1)) {
          navigate('/admin')
        }
        else {
          setError("You don't have access to this tab")
        }
        break;
      case "findAsset":
        if (roles.includes(10) || roles.includes(1)) {
          // navigate('/findasset')
        }
        else {
          setError("You don't have access to this tab")
        }
      case "assetMovement":
        if (roles.includes(11) || roles.includes(1)) {
          navigate('/movement')
        }
        else {
          setError("You don't have access to this tab")
        }
        break;
      default:
        break;

    }

  }

  return (
    <div>
      <style>
        {`
        .responsive-text {
              font-size: 1.3rem;
            }

          @media (max-width: 1000px) {
            .responsive-text {
              font-size: 14px;
            }
          }
        `}
      </style>
      <div className={`p-0 h-full ${i18n.language === 'ar' ? 'sm:mr-72' : 'sm:ml-72'}`}>
        <ViewportMeta />

        {error && <CustomSnakebar message={error} severity="error" onClose={resetSnakeBarMessages} />}
        <div className='h-screen w-full'>
          {/* <!-- Sidebar --> */}
          {/* <div class="fixed left-0 2xl:mt-0 xl:mt-0 lg:mt-0 md:mt-0 w-14 md:w-64 pt-5 bg-blue-900 dark:bg-gray-900 h-full text-white border-none overflow-scroll">

          <div class="flex flex-col justify-between">
            <ul class="flex flex-col py-4 space-y-5">
              <li onClick={() => handleNavigation("assetCapture")} className='cursor-pointer'>
                <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                  <img src={assetcapture}
                    className='h-5 w-5' alt='' />
                </span>
                <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">Asset Capture</span>
              </li>
              <li onClick={() => handleNavigation("generateTags")}
                // onClick={() =>
                //   navigate('/newasset') } 
                className='cursor-pointer'>
                <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                  <img src={newtags} className='h-5 w-5' alt='' />
                </span>
                <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">New Asset (Generate Tags)</span>
              </li>
              <li
                // onClick={() => navigate('/userprinting')}
                onClick={() => handleNavigation("assetForPrinting")}
                className='cursor-pointer'>
                <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                  <img src={assetprinting} className='h-5 w-5' alt='' />
                </span>
                <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">Asset for Printing</span>
              </li>
              <li
                // onClick={() => navigate('/verifiedasset')} 
                onClick={() => handleNavigation("verifiedAssets")}
                className='cursor-pointer'>
                <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                  <img src={assetverified} className='h-5 w-5' alt='' />
                </span>
                <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">Verified Assets</span>
              </li>
              <li
                // onClick={() => navigate('/movement')}
                onClick={() => handleNavigation("assetMovement")}
                className='cursor-pointer'>
                <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                  <img src={assetmovement} className='h-5 w-5' alt='' />
                </span>
                <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">Asset Movement</span>
              </li>
              <li
                //  onClick={() => navigate('/cust')}
                onClick={() => handleNavigation("custodian")}
                className='cursor-pointer'>
                <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                  <img src={assetcustodian} className='h-5 w-5' alt='' />
                </span>
                <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">Asset By Custodian</span>
              </li>
              <li
                // onClick={() => navigate('/location')} 
                onClick={() => handleNavigation("location")}
                className='cursor-pointer'>
                <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                  <img src={assetlocation} className='h-5 w-5' alt='' />
                </span>
                <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">Asset by locations</span>
              </li>
              <li
                onClick={() => handleNavigation("assetInventory")}

              >
                <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                  <img src={transaction} className='h-5 w-5' alt='' />
                </span>
                <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">Assets Inventory</span>
              </li>
              <li
                className='cursor-pointer'

                // onClick={() => navigate('/admin')}
                onClick={() => handleNavigation("admin")}
              >
                <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                  <img src={adminpanel} className='h-5 w-5' alt='' />
                </span>
                <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">Admin Panel</span>
              </li>
              <li onClick={() => navigate('/userlogin')} className='cursor-pointer'>
                <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                  <img src={logout1} className='h-5 w-5' alt='' />
                </span>
                <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">Log-out</span>
              </li>
              <li
                onClick={() => handleNavigation("findAsset")}
              >
                <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                  <img src={findasset} className='h-5 w-5' alt='' />
                </span>
                <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">Find Asset</span>
              </li>
              <li
                // onClick={() => navigate('/verify')} 
                onClick={() => handleNavigation("verify")}
                className='cursor-pointer'>
                <span class="inline-flex bg-white w-7 h-7 rounded-full justify-center items-center ml-4">
                  <img src={assetverification} className='h-5 w-5' alt='' />
                </span>
                <span class="xl:ml-2 2xl:ml-2 md:ml-2 ml-0 xl:text-sm 2xl:text-sm md:text-sm text-[7px] flex flex-col justify-center text-center md:inline-block tracking-wide">Asset Verification</span>
              </li>
            </ul>
          </div>
        </div> */}
          {/* <!-- ./Sidebar --> */}


          {/* <div class="min-h-screen h-full ml-14 mt-36 2xl:mt-0 xl:mt-0 lg:mt-0 md:mt-0 md:ml-64 flex flex-col justify-center"> */}
          <div class="h-auto flex flex-col justify-center">

            {/* <!-- Statistics Cards --> */}
            <div class="grid grid-cols-1 sm:grid-cols-3 p-4 gap-4 bg-gradient-to-r from-[#EBEDFD]">
              <div
                className={`bg-gray-50    shadow-lg cursor-pointer rounded-md flex items-center gap-3 p-3 border-b-4 border-blue-600 font-medium group ${i18n.language === 'ar' ? 'direction-rtl' : 'direction-ltr'}`}
                style={{ flexWrap: 'wrap' }}
              >
                <div class="flex justify-center items-center w-8 h-8 bg-white rounded-full transition-all duration-300 transform group-hover:rotate-45 sm:w-11 sm:h-11 lg:w-14 lg:h-14 xl:w-14 xl:h-14 2xl:w-14 2xl:h-14">
                  <img src={assetcapture} className="h-5 w-auto sm:h-8 sm:w-auto" alt="" />
                </div>
                <div className="text-right responsive-text"
                  style={{ display: 'flex', flexDirection: 'rew', justifyContent: 'flex-end', alignItems: 'center', gap: '10px' }}
                >
                  <p className=""
                    // don't break words on small screen
                    style={{ whiteSpace: "nowrap" }}
                  >{t("New Assets")}</p>
                  <span>{newassetData.length > 0 ? newassetData.length : null}</span>
                </div>
              </div>

              <div className={`bg-gray-50   shadow-lg cursor-pointer rounded-md flex items-center gap-3 p-3 border-b-4 border-blue-600 font-medium group ${i18n.language === 'ar' ? 'direction-rtl' : 'direction-ltr'}`}
                style={{ flexWrap: 'wrap' }}
              >
                <div class="flex justify-center items-center w-8 h-8 bg-white rounded-full transition-all duration-300 transform group-hover:rotate-45 sm:w-11 sm:h-11 lg:w-14 lg:h-14 xl:w-14 xl:h-14 2xl:w-14 2xl:h-14">
                  <img src={assetprinting} className="h-5 w-auto sm:h-8 sm:w-auto" alt="" />
                </div>
                <div className="text-right responsive-text"
                  style={{ display: 'flex', flexDirection: 'rew', justifyContent: 'flex-end', alignItems: 'center', gap: '10px', }}
                >
                  <p className=""
                    // don't break words on small screen
                    style={{ whiteSpace: "pre-wrap" }}
                  >{t("Printing Assets")}</p>
                  <span>{PrintingAssetData.length > 0 ? PrintingAssetData.length : null}</span>
                </div>
              </div>

              <div
                className={`bg-gray-50   shadow-lg cursor-pointer rounded-md flex items-center gap-3 p-3 border-b-4 border-blue-600 font-medium group ${i18n.language === 'ar' ? 'direction-rtl' : 'direction-ltr'}`}
                style={{ flexWrap: 'wrap' }}
              >
                <div class="flex justify-center items-center w-8 h-8 bg-white rounded-full transition-all duration-300 transform group-hover:rotate-45 sm:w-11 sm:h-11 lg:w-14 lg:h-14 xl:w-14 xl:h-14 2xl:w-14 2xl:h-14">
                  <img src={assetverified} className="h-5 w-auto sm:h-8 sm:w-auto" alt="" />
                </div>
                <div className="text-right responsive-text"
                  style={{ display: 'flex', flexDirection: 'rew', justifyContent: 'flex-end', alignItems: 'center', gap: '10px' }}
                >
                  <p className=""
                    style={{ whiteSpace: "nowrap" }}

                  >{t("Verified Assets")}</p>
                  <span>{allVerifiedAssetsList.length > 0 ? allVerifiedAssetsList.length : null}</span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 p-4 gap-4 bg-gradient-to-r from-[#5666e2]">
              {/* <!-- Social Traffic --> */}
              <div className="relative flex flex-col min-w-0 mb-4 md:mb-0 break-words bg-gray-50  w-full shadow-lg rounded">
                <DashboardTable data={newassetData} columnsName={allUserAssetsColumns(t)} UniqueId="newTagsId" secondaryColor='secondary'
                  title={t("New Assets")} />
              </div>
              {/* <!-- Social Traffic2 --> */}
              <div className="relative flex flex-col min-w-0 mb-4 md:mb-0 break-words bg-gray-50 w-full shadow-lg rounded">
                <DashboardTable data={PrintingAssetData} columnsName={allUserAssetsColumns(t)} secondaryColor='secondary'
                  UniqueId="assetPrintingId" title={t("Printing Assets")} />
              </div>
              {/* <!-- Recent Activities --> */}
              <div className="relative flex flex-col min-w-0 break-words bg-gray-50  w-full shadow-lg rounded md:col-span-2">
                <DashboardTable data={allVerifiedAssetsList} columnsName={allUserAssetsColumns(t)} secondaryColor='secondary'
                  UniqueId="newTagsId" title={t("Verified Assets")} />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div >
  )
}

export default AssetsDashboard